import { useState } from 'react';
import { useForm, SubmitHandler } from 'react-hook-form';
import isStrongPassword from 'validator/lib/isStrongPassword';

import { ResetPasswordReq } from 'services/auth.service';
import { useAppDispatch } from 'store/store-hooks';
import { Path, useAuthNavigator } from 'components/_hooks/use-router';
import { resetPassword } from '../auth.slice';

import { Button } from 'components/UI/button/button';
import { InputGroup } from 'components/UI/input/input-group';
import { InputBase } from 'components/UI/input/elements/input-base';
import styles from '../_auth.module.scss';

export const AuthResetPass = () => {
  const [isPending, setIsPending] = useState<boolean>(false);
  const dispatch = useAppDispatch();
  const { navigateTo } = useAuthNavigator();
  const {
    register,
    handleSubmit,
    getValues,
    formState: { errors },
  } = useForm<ResetPasswordReq>();

  const onSubmit: SubmitHandler<ResetPasswordReq> = async (data) => {
    setIsPending(true);
    dispatch(resetPassword(data))
      .unwrap()
      .then((res) => {
        if (res === 'logIn') navigateTo(Path.login);
      })
      .finally(() => setIsPending(false));
  };

  return (
    <div className={styles.Login}>
      <h3 className={styles.title}>Reset Password</h3>
      <p className={styles.desc}>We’ve sent a One-Time Password (OTP) to your registered email.</p>
      <p className={styles.desc}>Please enter the code below to continue.</p>
      <form className={styles.form} onSubmit={handleSubmit(onSubmit)}>
        <InputGroup header="OTP Code" error={errors.otpCode?.message}>
          <InputBase
            placeholder="Enter OTP Code"
            {...register('otpCode', {
              required: 'The OTP Code is required',
              validate: (value) => value.length === 8 || 'Must be 8 characters',
            })}
            alert={!!errors.otpCode?.message}
          />
        </InputGroup>
        <InputGroup header="Password" error={errors.newPassword?.message}>
          <InputBase
            type="password"
            placeholder="Enter your password"
            {...register('newPassword', {
              required: 'The Password is required',
              validate: (value) =>
                isStrongPassword(value) || 'Requirements: lower/upper case, letters, numbers/symbols',
            })}
            alert={!!errors.newPassword?.message}
          />
        </InputGroup>
        <InputGroup header="Confirm Password" error={errors.confirmNewPassword?.message}>
          <InputBase
            type="password"
            placeholder="Confirm your password"
            {...register('confirmNewPassword', {
              required: 'The Password is required',
              validate: (value) => getValues('newPassword') === value || "Passwords don't match",
            })}
            alert={!!errors.confirmNewPassword?.message}
          />
        </InputGroup>
        <footer>
          <Button disabled={isPending || !!Object.keys(errors).length}>Reset</Button>
        </footer>
      </form>
    </div>
  );
};
